var _effectorFileName = "/src/page-content/teachers/model.ts";
import { pagesPath } from '@/shared/config/$path';
import { declarePage } from '@/shared/lib/effector/page';
export const teachersPage = declarePage({
  pageType: pagesPath.$url().pathname
});